import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';
import unorm from 'unorm';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

// Style for the autocomplete dropdown menu
const menuStyle = {
  boxShadow: '0px 2px 10px 1px rgba(0, 0, 0, 0.25)',
  background: 'white',
  fontSize: '90%',
  position: 'absolute',
  top: '30px',
  left: 0,
  zIndex: 2,
  overflow: 'auto',
  maxHeight: '300px',
  width: '100%'
};

// Style for the wrapper container
const wrapperStyle = {
  width: '100%'
};

// Style for the input field
const style = {
  background: '#fff',
  outline: 'none',
  color: 'rgb(185, 183, 183)',
  border: 'solid 1px #ccc',
  borderRadius: '4px',
  fontSize: '12px',
  padding: '6px 8px',
  width: '100%',
  fontFamily: 'latoregular'
};

// Style function for menu items, highlighting selected elements
const styleMenu = isHighlighted => {
  return {
    color: isHighlighted ? 'white' : '#687676',
    background: isHighlighted ? '#f99e60' : 'white',
    padding: '8px 5px',
    textAlign: 'left'
  };
};

// Constants for pagination
const INITIAL_ITEMS_COUNT = 20;
const SCROLL_ITEMS_COUNT = 10;

/**
 * Autocomplete component with support for lazy loading
 * This component allows searching in a list of elements and loads more elements as the user scrolls
 */
class AutocompleteHomologationComponent extends Component {
  /**
   * Constructor initializes the state and creates a unique ID for this component instance
   * @param {Object} props - Component properties
   */
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      memory: props.value,
      filter: props.filter,
      displayedItems: [],
      currentPage: 0,
    };
    // Generate a unique ID for this component instance to avoid conflicts when using multiple instances
    this.instanceId = `autocomplete-driver-${uuidv4()}`;
  }

  /**
   * Loads more items for the autocomplete dropdown
   */
  loadMoreItems = () => {
    const { filter, currentPage, displayedItems } = this.state;

    // If we already have loaded elements, start from the number we already have
    const startIndex = displayedItems.length;

    const endIndex = startIndex + SCROLL_ITEMS_COUNT;
    const newItems = filter.slice(startIndex, endIndex);

    if (newItems.length > 0) {
      // Important: Capture the element and its position BEFORE state update
      // Get the current autocomplete menu element
      const menuElement = document.getElementById(this.instanceId);
      let scrollTop = 0;

      // If we found the element, save its scroll position
      if (menuElement) {
        scrollTop = menuElement.scrollTop;
      }

      this.setState({
        displayedItems: [...displayedItems, ...newItems],
        currentPage: currentPage + 1,
        hasMoreItems: endIndex < filter.length
      }, () => {
        // After React updates the DOM, restore the scroll position
        if (menuElement) {
          // Use requestAnimationFrame to ensure DOM is updated
          requestAnimationFrame(() => {
            menuElement.scrollTop = scrollTop;
          });
        }
      });
    } else {
      this.setState({ hasMoreItems: false });
    }
  }

  /**
   * Handles changes to the input field
   * @param {Event} e - The change event
   * @param {string} value - The new input value
   * @param {Array} arr - The array of items
   */
  handleChange = (e, value, arr) => {
    const alias = this.props.alias;
    const aliasTwo = this.props.aliasTwo;
    let filteredItems = _.filter(this.props.filter, function(item) {
      const a = unorm
        .nfd(item[alias])
        .toUpperCase()
        .replace(/[\u0300-\u036f]/g, '');
      const b = unorm
        .nfd(value)
        .toUpperCase()
        .replace(/[\u0300-\u036f]/g, '');
      const c = unorm
        .nfd(item[aliasTwo])
        .toUpperCase()
        .replace(/[\u0300-\u036f]/g, '');
      const d = unorm
        .nfd(value)
        .toUpperCase()
        .replace(/[\u0300-\u036f]/g, '');
      return a.includes(b) || c.includes(d);
    });

    this.setState({
      value: value,
      filter: filteredItems
    }, () => {
      this.initializeFilters(filteredItems);
    });
  };

  /**
   * Initializes filters with new data, typically used when the search query changes
   * @param {Array} filterData - The filtered data to display
   */
  initializeFilters = (filterData) => {
    this.setState({
      filter: filterData,
      displayedItems: filterData.slice(0, INITIAL_ITEMS_COUNT),
      currentPage: 1,
      hasMoreItems: filterData.length > INITIAL_ITEMS_COUNT
    });
  };

  /**
   * Handles click on the input field
   * @param {Event} event - The click event
   */
  handleClick = (event) => {
    this.setState({ value: '' }, () => {
      this.initializeFilters(this.props.filter);
    });
  };

  /**
   * Handles blur event on the input field
   * @param {Event} event - The blur event
   */
  handleBlur = (event) => {
    this.setState({
      value: this.state.memory,
      filter: this.props.filter
    });
  };

  /**
   * Handles selection of an item from the dropdown
   * @param {string} value - The selected value
   * @param {Object} arr - The selected item object
   */
  handleSelect = (value, arr) => {
    this.setState({
      value: value,
      memory: value
    });
    const obj = {
      id: this.props.id,
      num: this.props.correlativo,
      value: arr,
      alias: this.props.alias
    };
    this.props.handleSubmit(obj);
  };

  /**
   * Handles clearing the selected value
   */
  handleClear = (value) => {
    this.setState({
      value: this.props.value,
      memory: this.props.value
    }, () => {
      this.initializeFilters(this.props.filter);
    });
    const obj = {
      id: this.props.id,
      num: this.props.correlativo,
      value: null,
      alias: this.props.alias
    };
    this.props.handleSubmit(obj);
  };

  /**
   * Handles scroll events in the autocomplete menu
   * @param {Event} e - The scroll event
   */
  handleScroll = (e) => {
    const element = e.currentTarget;
    if (!this.state.hasMoreItems) return;

    const scrollPosition = element.scrollTop + element.clientHeight;
    const scrollThreshold = element.scrollHeight * 0.8; // 80% of container

    if (scrollPosition >= scrollThreshold) {
      this.loadMoreItems();
    }
  };

  /**
   * Renders the component
   * @returns {JSX.Element} The rendered component
   */
  render() {
    const typeRow = this.props.valores[this.props.correlativo];
    const count = document.querySelectorAll('[data-homologation]').length;

    const homologations = [];
    let i;
    let homologation, source, row, externalid, check, input;
    for (i = 0; i <= count - 1; i++) {
      if (document.getElementById(`homologation-id-${i}`)) {
        homologation = document.getElementById(`homologation-id-${i}`).value;
        source = document.getElementById(`homologation-datasource-${i}`).value;
        input = document.getElementById(`au-${i}`);
        if (homologation != '' && input.classList.contains('active-au')) {
          homologations.push({
            dataSource: source,
            name: input.value
          });
        }
      }
    }

    const arrFinal = [];

    // Filter already homologated items
    this.state.displayedItems.map(item => {
      const objFInal = homologations.find(o => {
        return o.name === item.alias && typeRow.dataSource === o.dataSource;
      });
      if (!objFInal) {
        arrFinal.push(item);
      }
    });

    return (
      <div className="box-clear">
        <Autocomplete
          inputProps={{
            'data-autocomplete': 'complete',
            'data-num': this.props.correlativo,
            id: this.props.id,
            style: style,
            onClick: this.handleClick,
            onBlur: this.handleBlur
          }}
          wrapperStyle={wrapperStyle}
          getItemValue={item => item[this.props.alias]}
          items={arrFinal}
          renderMenu={(items, value, style) => (
            <div
              id={this.instanceId}
              style={{ ...menuStyle }}
              onScroll={this.handleScroll}
            >
              {items}
            </div>
          )}
          renderItem={(item, isHighlighted) => (
            <div key={item[this.props.idItem]} style={styleMenu(isHighlighted)}>
              {`${item[this.props.alias]} - ${item[this.props.aliasTwo]}`}
            </div>
          )}
          value={this.state.value}
          onChange={this.handleChange}
          onSelect={this.handleSelect}
        />
        {this.state.memory != this.props.value && (
          <div className="box-clear-button">
            <button onClick={this.handleClear}>
              <i className="fas fa-times-circle" />
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default AutocompleteHomologationComponent;


// WEBPACK FOOTER //
// ./source/client/components/common/autocompleteHomologation.jsx